import useScrollFade from '../../../hooks/useScrollFade';

const highlights = [
  {
    icon: 'ri-time-line',
    label: '20+ Years Experience',
    description: 'Two decades leading technology strategy and software delivery across enterprise organizations.',
  },
  {
    icon: 'ri-building-4-line',
    label: 'Enterprise Architecture',
    description: 'Designed scalable, resilient systems trusted by thousands of users across complex business environments.',
  },
  {
    icon: 'ri-refresh-line',
    label: 'Legacy Modernization',
    description: 'Proven track record transforming outdated platforms into modern, maintainable, high-performance solutions.',
  },
];

const ExperienceSection = () => {
  const left = useScrollFade();
  const right = useScrollFade({ delay: 120 });
  const card0 = useScrollFade({ delay: 160 });
  const card1 = useScrollFade({ delay: 260 });
  const card2 = useScrollFade({ delay: 360 });
  const cardRefs = [card0, card1, card2];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left — Headline + Paragraphs */}
          <div ref={left.ref} className={left.fadeClass}>
            <p className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">
              Authority &amp; Experience
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-8">
              Technology Leadership Backed by Real Experience
            </h2>
            <div className="space-y-5 text-gray-600 text-[15px] leading-relaxed">
              <p>
                We've designed and delivered enterprise software systems across multiple industries including healthcare, logistics, travel, and financial services.
              </p>
              <p>
                We've partnered with startups finding their footing and Fortune 500 companies navigating complex transformations — bringing the same disciplined, outcome-focused approach to every engagement.
              </p>
              <p>
                Our work spans the full technology lifecycle: from defining architecture and building engineering teams to modernizing legacy platforms and aligning technology roadmaps with business strategy.
              </p>
            </div>
          </div>

          {/* Right — 3 Key Highlights */}
          <div ref={right.ref} className={`flex flex-col gap-5 ${right.fadeClass}`}>
            {highlights.map((item, index) => {
              const { ref, fadeClass } = cardRefs[index];
              return (
                <div
                  key={index}
                  ref={ref}
                  className={`flex items-start gap-5 bg-gray-50 border border-gray-100 rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 ${fadeClass}`}
                >
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 rounded-xl bg-gray-900">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h4 className="text-gray-900 font-semibold text-base mb-1">{item.label}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
